<!--
 * @Author: etong
 * @Date: 2021-07-15 11:43:44
 * @LastEditTime: 2022-08-05 16:01:44
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @Description:
 * @FilePath: \oak\src\components\JJVisNetwork\content.vue
 * Think first, Program later
 * https://ame.cool/pages/a7d858/  中文文档
-->

<template>
  <div>
    <!--width,height 画布的宽度，高度。 可以是百分比或像素，一般在dom元素上设置 -->
    <div id="network_id" :style="{height:height}" class="network"></div>
    <Contextmenu v-if="isShowContextmenu" ref="menu" :offset-y="offsetY" :offset-x="offsetX" >
      <div slot="menuList" >
        <slot :scopeRow="nodeObject" name="contextMenuListSlots">
        </slot>
      </div>
    </Contextmenu>

  </div>
</template>

<script>
import { Network, DataSet } from 'vis-network/standalone'
import Contextmenu from '@/components/Contextmenu'
export default {
  name: 'JJVisNetwork',
  components: {
    Contextmenu
  },
  directives: {
  },
  props: {
    // 点击是否需要跳转自定义路由
    isCustomRoute: {
      type: Boolean,
      default: false
    },
    // 自定义路由的参数
    // route 路由 即完整的path
    // params 传递的参数
    customeRouteParams: {
      type: Object,
      default: () => {}
    },
    // 节点数组
    nodesArray: {
      type: Array,
      default: () => []
    },
    // 关系数组
    edgesArray: {
      type: Array,
      default: () => []
    },
    // 右键操作
    isShowContextmenu: {
      type: Boolean,
      default: false
    },
    // 右键菜单的偏移量
    offsetY: {
      type: Number,
      default: 0
    },
    offsetX: {
      type: Number,
      default: 0
    },
    // 布局配置项
    hierarchical: {
      type: Object,
      default: function() {
        return { enabled: false }
      }
    },
    // 用于所有用户与网络的交互。处理鼠标和触摸事件以及导航按钮和弹出窗口
    interaction: {
      type: Object,
      default: function() {
        return {
          dragNodes: true, // 是否能拖动节点
          dragView: true, // 是否能拖动画布
          hover: true, // 鼠标移过后加粗该节点和连接线
          multiselect: true, // 按 ctrl 多选
          selectable: true, // 是否可以点击选择
          selectConnectedEdges: true, // 选择节点后是否显示连接线
          hoverConnectedEdges: true, // 鼠标滑动节点后是否显示连接线
          zoomView: true // 是否能缩放画布
        }
      }
    },
    // 视图缩放、动画,可根据节点，偏移量设置视图缩放的方式
    onceStabilized: {
      type: Function,
      default: null
    },
    // 画布的高度
    height: {
      type: String,
      default: '60vh'
    }

  },
  data() {
    return {
      nodes: [],
      edges: [],
      container: null,
      options: {
        autoResize: true, // 网络将自动检测其容器的大小调整，并相应地重绘自身
        locale: 'cn', // 语言设置：工具栏显示中文
        layout: {
          randomSeed: 2,
          // hierarchical 布局配置项，通过父组件传入，详细信息参考官方文档
          hierarchical: this.hierarchical
          // hierarchical: {
          //   enabled: true,
          //   levelSeparation: 200,
          //   nodeSpacing: 200,
          //   treeSpacing: 500,
          //   blockShifting: true,
          //   edgeMinimization: true,
          //   parentCentralization: true,
          //   direction: 'LR', // UD, DU, LR, RL
          //   sortMethod: 'directed', // hubsize, directed
          //   shakeTowards: 'roots' // roots, leaves
          // }
        },

        groups: {
          useDefaultGroups: true,
          myGroupId: {},
          ws: {
            // 系统定义的形状dot等这些官网都可以找到
            shape: 'dot',
            color: 'white'
          }
        },
        // 设置节点样式
        nodes: {
          shape: 'box',
          font: {
            // 字体配置
            size: 18
          },
          borderWidth: 0, // 节点边框宽度，单位为px
          borderWidthSelected: 2 // 节点被选中时边框的宽度，单位为px
        },
        // 边线配置
        edges: {
          width: 1,
          length: 260,
          // font: { align: 'top' },
          color: {
            color: '#848484',
            highlight: '#848484',
            hover: '#848484',
            inherit: 'from',
            opacity: 1.0
          },
          shadow: true,
          smooth: {
            // 设置两个节点之前的连线的状态
            enabled: true // 默认是true，设置为false之后，两个节点之前的连线始终为直线，不会出现贝塞尔曲线
          },
          arrows: { to: true } // 箭头指向 to
        },
        // // 计算节点之前斥力，进行自动排列的属性
        physics: {
          enabled: true, // 默认是true，设置为false后，节点将不会自动改变，拖动谁谁动。不影响其他的节点
          barnesHut: {
            gravitationalConstant: -4000,
            centralGravity: 0.3,
            springLength: 120,
            springConstant: 0.04,
            damping: 0.09,
            avoidOverlap: 0
          }
        },
        // 用于所有用户与网络的交互。处理鼠标和触摸事件以及导航按钮和弹出窗口
        // 因为考虑到有点图不需要点击事件，所以 interaction 修改为 外部传入，默认是有 点击事件的
        interaction: this.interaction
        // interaction: {
        //   dragNodes: true, // 是否能拖动节点
        //   dragView: true, // 是否能拖动画布
        //   hover: true, // 鼠标移过后加粗该节点和连接线
        //   multiselect: true, // 按 ctrl 多选
        //   selectable: true, // 是否可以点击选择
        //   selectConnectedEdges: true, // 选择节点后是否显示连接线
        //   hoverConnectedEdges: true, // 鼠标滑动节点后是否显示连接线
        //   zoomView: true // 是否能缩放画布
        // }
      },
      data: {},
      nodeObject: {}
    }
  },
  computed: {},
  watch: {
    nodesArray: {
      handler: function(newVal, oldVal) {
        if (newVal && newVal.length > 0) {
          this.initData()
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    /**
     * @description: 初始化当前节点 关系形成关系图
     * @param {*}
     * @return {*}
     */
    initData() {
      this.nodes = new DataSet(this.nodesArray)
      this.edges = new DataSet(this.edgesArray)
      this.container = document.querySelector('#network_id')
      this.resetAllNodesStabilize()
      // 初始化当前节点 关系形成关系图
      // 点击事件 跳转详情
      this.network.on('click', params => {
        let mergeQueryOption = {}
        const _nodeArray = this.nodesArray.slice(0)
        if (!params.nodes[0]) {
          return false
        }
        // 取出当前点击节点对象
        const { docModel, id } = _nodeArray.filter(item => item.id === params.nodes[0])[0]
        // 跳转详情地址
        const goToDetailPath = `/commonForm/${docModel}`
        mergeQueryOption = {
          id,
          t: +new Date(),
          parent_t: this.$route.query.t,
          type: 3, // 1 新增 2 修改 3 查看 4 复制
          backPath: this.$route.path // 从哪来回哪去
        }

        // 需要特殊自定义路由 同时有需要传递的参数 将进行对象合并
        this.isCustomRoute &&
        this.customeRouteParams['params'] &&
        Object.assign(mergeQueryOption, this.customeRouteParams['params'])

        this.$router.push({
          // 路由处理 看是否需要自定义
          path: this.isCustomRoute ? this.customeRouteParams['route'] : goToDetailPath || '',
          query: mergeQueryOption
        })
      })
      // 鼠标右键事件
      this.network.on('oncontext', (params) => {
        const nodeId = this.network.getNodeAt(params.pointer.DOM) // 获取当前点击节点的 id
        const _nodeArray = this.nodesArray.slice(0)
        if (!nodeId) {
          return false
        }
        // 取出当前点击节点对象,通过插槽传出
        this.nodeObject = _nodeArray.filter(item => item.id === nodeId)[0]
        const row = {}
        const column = {}
        this.isShowContextmenu && this.$refs.menu.openMenu(row, column, event)
      })

      // 视图缩放、动画,可根据节点，偏移量设置视图缩放的方式
      this.onceStabilized && this.onceStabilized(this.network)
    },
    /**
     * @description: 重置节点数据 关系数据
     * @param {*}
     * @return {*}
     */
    resetAllNodes() {
      this.nodes.clear()
      this.edges.clear()
      this.nodes.add(this.nodesArray)
      this.edges.add(this.edgesArray)
      this.data = {
        nodes: this.nodes,
        edges: this.edges
      }
      // network是一种用于将包含点和线的网络和网络之间的可视化展示
      this.network = new Network(
        this.container,
        this.data,
        this.options
      )
    },
    resetAllNodesStabilize() {
      this.resetAllNodes()
      this.network.stabilize()
    }

  }
}
</script>
<style lang='scss' scoped>

</style>
